module.exports = __webpack_public_path__ + "img/refresh.2b6eb674.svg";